import {
  Button,
  Select, Spin, Table,
} from 'antd';
import React, {
  Fragment, useEffect, useMemo, useState,
} from 'react';
import dayjs from 'dayjs';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import SelectDepartment from '@Components/Common/SelectDepartment';
import { toISTDate } from '@Apis/constants';
import TagSelector from '@Components/Common/Selector/TagSelector';
import SelectUser from '@Components/Common/SelectUser';
import SelectCustomer from '@Components/Common/SelectCustomer';
import TenantActions from '@Actions/tenantActions';
import H3DateSelector from '@Uilib/h3DateSelector';
import ProductActions from '@Actions/productActions';
import SOActions from '@Actions/sales/soActions';
import mrpV2Actions from '../../../../../../actions/production/mrpV2Actions';
import SelectAppUser from '../../../../../Common/SelectAppUser';
import documentUINamesConstant from '../../../../../../apis/documentUINamesConstant';
import PRZSelect from '../../../../../Common/UI/PRZSelect';

const { Option } = Select;

const FiltersToAddSo = ({
  user, history, customStatusSalesOrder, getCustomStatus, getOrgUsers, tenantId,
  getSO, getSOLoading, LinkSoToMRP, callback, mrpId, LinkSoToMRPLoading, mrpData, products, getProductsLoading, getProducts,
}) => {
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedCustomStatus, setSelectedCustomStatus] = useState([]);
  const [selectedCustomStatusId, setSelectedCustomStatusId] = useState('');
  const [fulfillmentStatus, setFulfillmentStatus] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [selectedTag, setSelectedTag] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [fromOrderDate, setFromOrderDate] = useState(null);
  const [toOrderDate, setToOrderDate] = useState(null);
  const [fromDeliveryDate, setFromDeliveryDate] = useState(null);
  const [toDeliveryDate, setToDeliveryDate] = useState(null);
  const [soData, setSoData] = useState(null);
  const [searchByProduct, setSearchByProduct] = useState('');
  const [selectedProductIds, setSelectedProductIds] = useState([]);

  const handleChange = (value) => {
    setSelectedProductIds(value);
  };

  useEffect(() => {
    // Start a timer with the debounce delay
    const handler = setTimeout(() => {
      if (searchByProduct) {
        getProducts(searchByProduct, user?.tenant_info?.tenant_id, '', 5, 1, '', '', '', '', '', '', '');
      }
    }, 500); // 500ms debounce time
    // Cleanup function to clear the timer
    return () => {
      clearTimeout(handler);
    };
  }, [searchByProduct]);

  useEffect(() => {
    setFulfillmentStatus(['pending', 'partial']);
    getCustomStatus({
      entityName: 'SALES_ORDER',
      orgId: user?.tenant_info?.org_id,
    }, (stausData) => {
      setSelectedCustomStatus(stausData?.data?.statuses
        ?.filter((item) => item.type === 'CONFIRMED')?.map((item) => item?.status_name));
    });
    getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => { });
  }, []);

  const getMrpColumns = () => {
    const mrpColumns = [
      {
        title: 'Order#',
        width: '160px',
        dataIndex: 'sales_order_number',
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Customer',
        render: (text, record) => (
          <div className="company__name" style={{ fontWeight: '600' }}>
            {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
              Helpers.permissionTypes.READ, user)
              ? (record?.customer_info?.customer_name ? (
                <Link to={`/sales/customer/view/${record?.customer_id}`} target="_blank">
                  {`${record?.internal_cust_code || ''} - ${record?.customer_info?.customer_name}`}
                </Link>
              ) : '-') : (`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Items',
        width: '60px',
        render: (item) => item?.line_count || 0,
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Payment Status',
        render: (item) => (
          <Fragment>
            <div className="shopify-order-statuses">
              <div
                className="shopify-order-statuses__item"
                style={{ color: Helpers.getStatusColor(item?.payment_status)?.color }}
              >
                {item.payment_status?.replaceAll('_', ' ')}
              </div>
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Fulfillment Status',
        render: (item) => (
          <Fragment>
            <div className="shopify-order-statuses">
              <div
                className="shopify-order-statuses__item"
                style={{ color: Helpers.getStatusColor(item?.fulfillment_status?.toUpperCase())?.color }}
              >
                {item.fulfillment_status?.toUpperCase()?.replaceAll('_', ' ')}
              </div>
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Order Date',
        width: '100px',
        render: (record) => (
          <div>
            {dayjs(record?.order_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Delivery Date',
        width: '140px',
        render: (text, record) => (
          <div>
            {toISTDate(record?.edd).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
      },
      {
        title: 'Status',
        width: '100px',
        render: (item) => (
          <div className="mo__status" style={{ color: Helpers.getStatusColor(item.status).color }}>
            {Helpers.getStatusColor(item.status).text?.toUpperCase()}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];
    // mrpColumns.push({
    //   title: '',
    //   key: 'action',
    //   className: 'list__actions-column',
    //   fixed: 'right',
    //   render: (text, record) => (
    //     <div className="list__actions">
    //       <div
    //         style={{ width: '100%' }}
    //         className="list__actions-button"
    //         onClick={() => {
    //           history.push(`/production/planning/view/${record.mrp_run_id}`);
    //         }}
    //       >
    //         View
    //       </div>
    //     </div>
    //   ),
    //   responsive: ['md', 'lg', 'xxl'],
    // });
    return mrpColumns;
  };

  const fulfillmentStatues = [
    { value: 'pending', label: 'Pending' },
    // { value: 'fulfilled', label: 'Fulfilled' },
    { value: 'partial', label: 'Partial' },
  ];

  const paymentStatues = [
    { value: 'PAID', label: 'Paid' },
    { value: 'NOT_PAID', label: 'Not Paid' },
    { value: 'PARTIALLY_PAID', label: 'Partially Paid' },
    { value: 'PAID_MORE', label: 'Paid More' },
  ];

  const handleSearchFilters = () => {
    getSO(
      {
        orgId: user?.tenant_info?.org_id,
        tenantId,
        customerId: selectedCustomer,
        fulfillmentStatus,
        departmentId: selectedDepartment,
        listScreen: true,
        paymentStatus,
        secondaryStatus: selectedCustomStatus?.length ? selectedCustomStatus : customStatusSalesOrder?.statuses
          ?.filter((item) => item.type === 'CONFIRMED')?.map((item) => item?.status_name),
        tags: selectedTag,
        accountManagerIds: selectedAssignee || null,
        fromDeliveryDate,
        toDeliveryDate,
        fromOrderDate,
        toOrderDate,
        isLinkedMrp: 'false',
        page: 1,
        limit: 100,
        productSkuIds: selectedProductIds,
        orderType: 'SALES_ORDER,ANNUAL_MAINTENANCE_CONTRACT',
      }, (data) => {
        setSoData(data?.data?.sales_orders);
      },
    );
  };

  const getDataSource = (data) => {
    if (data) {
      // Create a deep copy of the data
      const copyData = JSON.parse(JSON.stringify(data));

      // Filter the data to include only items with mrp_id, then map it to add the key property
      return copyData
        ?.filter((item) => !item?.mrp_id) // Ensure item has mrp_id
        ?.map((item) => ({ ...item, key: item?.order_id })); // Map to add key property
    }
    return [];
  };

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  return (
    <Spin spinning={getSOLoading === true}>
      <div
        className="mrp__search-filters-main_container"
      >
        <div className="mrp__search-filters-container">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Department
            </label>
            <SelectDepartment
              title="Select Department"
              hideTitle
              selectedDepartment={selectedDepartment}
              noDropdownAlign
              onChange={(value) => {
                setSelectedDepartment(value?.department_id);
              }}
            />
          </div>
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Order Status
            </label>
            <PRZSelect
              value={selectedCustomStatus}
              onChange={(value) => {
                const requiredStatus = customStatusSalesOrder?.statuses?.filter((status) => status?.status_name === value)[0];
                setSelectedCustomStatus(value);
                setSelectedCustomStatusId(requiredStatus?.custom_status_id);
                setSelectedRowKeys(null);
                setSelectedRows(null);
              }}
              mode="multiple"
              placeholder="Order Status"
              maxTagCount="responsive"
            >
              {/* <Option key={null} value={null}> All Status</Option> */}
              {customStatusSalesOrder?.statuses
                ?.filter((item) => item.type === 'CONFIRMED') // Filter to keep only items with type "CONFIRMED"
                ?.map((item) => (
                  <Option key={item?.custom_status_id} value={item?.status_name}>
                    {item?.status_name?.split('_')?.join(' ')?.toProperCase()}
                  </Option>
                ))}
              {' '}

            </PRZSelect>
          </div>
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Fulfillment Status
            </label>
            <PRZSelect
              value={fulfillmentStatus}
              onChange={(value) => {
                setFulfillmentStatus(value);
              }}
              placeholder="Order Fulfillment Status"
              mode="multiple"
            >
              {/* <Option key={null} value={null}> All Fulfillment Status</Option> */}
              {fulfillmentStatues?.map((item) => <Option key={item} value={item.value}>{item.label}</Option>)}
            </PRZSelect>
          </div>

        </div>
        <div className="mrp__search-filters-container">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Payment Status
            </label>
            <PRZSelect
              value={paymentStatus}
              onChange={(value) => {
                setPaymentStatus(value);
              }}
              placeholder="Order Payment Status"
              mode="multiple"
              maxTagCount="responsive"
            >
              {/* <Option key={null} value={null}> All Payment Status</Option> */}
              {paymentStatues?.map((item) => <Option key={item} value={item.value}>{item.label}</Option>)}
            </PRZSelect>
          </div>
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Labels
            </label>
            <TagSelector
              filter
              entityType="SALES_ORDER"
              selectedTags={selectedTag}
              showSearch
              showAll={false}
              noDropdownAlign
              isMultiple
              onChange={(value) => {
                setSelectedTag(value);
              }}
              placeholder="Select Label"
              hideTitle
              hideCSS
            />
          </div>
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Delivery Date
            </label>
            <H3DateSelector
              startDate={fromDeliveryDate}
              endDate={toDeliveryDate}
              onDateChange={(date) => {
                if (date?.length === 2) {
                  setFromDeliveryDate(dayjs(date[0])?.startOf('day').valueOf());
                  setToDeliveryDate(dayjs(date[1])?.endOf('day').valueOf());
                } else {
                  setFromDeliveryDate(null);
                  setToDeliveryDate(null);
                }
              }}
              allowClear
              customStyle={{
                height: '28px',
                border: '1px solid rgba(45, 124, 247, 0.2)',
                borderRadius: '3px',
              }}
            />
          </div>

        </div>
        <div className="mrp__search-filters-container">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Order Date
            </label>
            <H3DateSelector
              startDate={fromOrderDate}
              endDate={toOrderDate}
              onDateChange={(date) => {
                if (date?.length === 2) {
                  setFromOrderDate(dayjs(date[0])?.startOf('day').valueOf());
                  setToOrderDate(dayjs(date[1])?.endOf('day').valueOf());
                } else {
                  setFromOrderDate(null);
                  setToOrderDate(null);
                }
              }}
              allowClear
              customStyle={{
                height: '28px',
                border: '1px solid rgba(45, 124, 247, 0.2)',
                borderRadius: '3px',
                marginTop: '0px,'
              }}
            />
          </div>
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Customer
            </label>
            <SelectCustomer
              selectedCustomer={selectedCustomer}
              allowClear
              onChange={(value) => setSelectedCustomer(value)}
              hideTitle
              isMultiple
              tenantId={[mrpData?.tenant_id]}
              hideCity
              maxTagCount="responsive"
            />
          </div>

          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Account Manager
            </label>
            <div>
              <SelectAppUser
                hideTitle
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                selectedUser={selectedAssignee}
                onChange={(value) => setSelectedAssignee(value)}
                isMultiple
                maxTagCount="responsive"
              />
            </div>
          </div>
        </div>
        <div
          className="mrp__search-filters-container"
          style={{
            marginTop: '-10px',
          }}
        >
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Product Name
            </label>
            <div>
              <PRZSelect
                showSearch
                mode="multiple"
                style={{ width: '100%' }}
                placeholder="Select a product"
                optionFilterProp="children"
                onSearch={(value) => setSearchByProduct(value)}
                value={selectedProductIds}
                onChange={handleChange}
                loading={getProductsLoading}
                filterOption={(input, option) => option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0}
              >
                {products?.result?.products?.map((product) => (
                  <Option key={product.product_sku_id} value={product.product_sku_id}>
                    {product?.product_info?.product_sku_name}
                  </Option>
                ))}
              </PRZSelect>
            </div>
          </div>
        </div>
        <Button
          type="primary"
          ghost
          onClick={() => {
            handleSearchFilters();
          }}
          style={{ marginTop: '-20px' }}
        >
          Search
        </Button>
        <div className="mrp__table" style={{ marginTop: '10px' }}>
          <Table
            title={() => (
              <div className="mrp__table-title">
                <H3Text text={`${getDataSource(soData)?.length || 0} ${documentUINames.salesOrderUIName}s`} className="" />
              </div>
            )}
            bordered
            showHeader
            size="small"
            loading={LinkSoToMRPLoading}
            columns={getMrpColumns()}
            dataSource={getDataSource(soData) || []}
            scroll={{ y: 'calc(100dvh - 430px)' }}// Set a fixed height for the table
            pagination={false}
            rowSelection={(window.screen.width > 425) ? {
              onChange: (rowKeys, rows) => {
                setSelectedRowKeys(rowKeys);
                setSelectedRows(rows);
              },
              selectedRowKeys,
            } : false}
          />
        </div>
      </div>
      <div className="custom-drawer__footer" style={{ width: '100%' }}>
        <div className="ant-col-md-6">
          <Button
            type="primary"
            onClick={() => {
              LinkSoToMRP({
                order_ids: selectedRowKeys.join(','),
                mrp_id: mrpId,
              }, () => {
                setSelectedRowKeys(null);
                setSelectedRows(null);
                callback();
              });
            }}
            loading={LinkSoToMRPLoading}
            disabled={LinkSoToMRPLoading}
          >
            {`Add ${documentUINames.salesOrderUIName}s`}
          </Button>
        </div>
      </div>
    </Spin>
  );
};
const mapStateToProps = ({
  UserReducers, CustomStatusReducers, TenantReducers, SOReducers, MrpV2Reducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  customStatusSalesOrder: CustomStatusReducers.customStatusSalesOrder,
  orgUsers: TenantReducers.orgUsers,
  getSOLoading: SOReducers.getSOLoading,
  LinkSoToMRPLoading: MrpV2Reducers.LinkSoToMRPLoading,
  products: ProductReducers.products,
  getProductsLoading: ProductReducers.getProductsLoading,

});

const mapDispatchToProps = (dispatch) => ({
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
  getSO: (payload, callback) => dispatch(SOActions.getSO(payload, callback)),
  LinkSoToMRP: (payload, callback) => dispatch(mrpV2Actions.LinkSoToMRP(payload, callback)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct)),
});

FiltersToAddSo.propTypes = {
  history: PropTypes.func,
  customStatusSalesOrder: PropTypes.any,
  getCustomStatus: PropTypes.func,
  user: PropTypes.any,
  orgUsers: PropTypes.any,
  getOrgUsers: PropTypes.func,
  getSOLoading: PropTypes.bool,
  getSO: PropTypes.func,
  LinkSoToMRP: PropTypes.func,
  LinkSoToMRPLoading: PropTypes.bool,
  mrpId: PropTypes.any,
  callback: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FiltersToAddSo));
